import React from 'react'
import {connect} from 'react-redux'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {errorMessage} from 'lib/styleguide/base.scss'
import {deleteGuidePage} from 'lib/api/experiences/guides'

class DeleteGuidePageDialog extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      deletePending: false,
      deleteError: false
    }
  }

  onConfirm = () => {
    const {guide, onRequestClose, expanded, setExpanded, deleteGuidePage} = this.props

    this.setState({deletePending: true})
    expanded && setExpanded(null)
    deleteGuidePage(guide)
      .then(() => { onRequestClose() })
      .catch(() => this.setState({deletePending: false, deleteError: true}))
  }

  render () {
    const {guide, onRequestClose} = this.props
    const {deletePending, deleteError} = this.state

    return (
      <ConfirmationDialog
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        confirmText='Yes, Delete this Section'
        onConfirm={this.onConfirm}
        confirmPending={deletePending}
        danger>
        <p>Are you sure you want to delete <strong>{guide.title}</strong>?</p>
        {deleteError && <div className={errorMessage}>
          Oops, we encountered an error while deleting this Experience. Please try again.
        </div>}
      </ConfirmationDialog>
    )
  }
}

const mapDispatchToProps = {
  deleteGuidePage: deleteGuidePage
}

export const DeleteGuidePageDialogContainer = connect(
  null,
  mapDispatchToProps
)(DeleteGuidePageDialog)
